import { fg } from '@confluence/feature-gating';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';
import { usePageContentId } from '@confluence/page-context';
import { createSingleQueryParamHook } from '@confluence/route-manager';

import type { AdfStats } from './useAdfStats';

const STATSIG_DYNAMIC_CONFIG = 'cc_complexit_page_id_allowlist';

const DEFAULT_COMPLEX_THREHOLD = 10000;
// complexitNodes value example: conplexitNodes=1000,10 where 1000 is the batch size and 10 is the multiplier
const useQueryParamComplexitNodes = createSingleQueryParamHook('complexitNodes');

type UseComplexPageProps = {
	adfStats: AdfStats;
};

export const useComplexPage = ({ adfStats }: UseComplexPageProps): boolean => {
	const [contentId] = usePageContentId();

	const complexitNodesConfig = useQueryParamComplexitNodes()?.split(',');
	const complexitNodes = Number(complexitNodesConfig?.[0]) * Number(complexitNodesConfig?.[1]);
	const complexityThreshold = isNaN(complexitNodes) ? DEFAULT_COMPLEX_THREHOLD : complexitNodes;

	const pageIdAllowList = StatsigConfigurations.getStringList(STATSIG_DYNAMIC_CONFIG, []);

	return (
		fg('cc_complexit_fe_progressive_rendering_condition') &&
		((!!contentId && pageIdAllowList.includes(contentId)) ||
			adfStats.totalNodeCount >= complexityThreshold)
	);
};
